import styled from 'styled-components';

import exagon from 'assets/splash_exagon.svg';
import repfy_logo_white from 'assets/repfy_logo_white.svg';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;

  width: 100vw;
  height: 100vh;

  overflow: hidden;

  background: linear-gradient(to bottom, #0078d7 10%, #b3e5f3 130%);

  animation: entering 0.5s ease-in;
`;

const Exagon = styled.div`
  position: absolute;

  height: 230px;
  width: 230px;

  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${exagon});

  @media (min-width: 580px) {
    height: 330px;
    width: 330px;
  }
`;

export const RightTop = styled(Exagon)`
  top: 0;
  right: 0;
  transform: translate(90px, -95px) rotate(223deg);

  animation: rightTopAnimation 2s ease-in-out forwards;
`;

export const RightBottom = styled(Exagon)`
  bottom: 0;
  right: 0;
  transform: translate(40px, 215px) rotate(14deg) scale(1.2);

  animation: rightBottomAnimation 2s ease-in-out forwards;
`;

export const LeftTop = styled(Exagon)`
  top: 0;
  left: 0;
  transform: translate(-130px, -105px) rotate(37deg);
  animation: leftTopAnimation 2s ease-in-out forwards;
`;

export const LeftCenter = styled(Exagon)`
  top: 50%;
  left: 0;
  transform: translate(-260px, -145px) rotate(111deg);
`;

export const LeftBottom = styled(Exagon)`
  bottom: 50px;
  left: -50px;

  transform: translate(-80px, 115px) rotate(234deg);
  animation: leftBottomAnimation 2s ease-in-out forwards;

  @media (min-width: 580px) {
    bottom: 0;
    left: 0;
  }
`;

export const RegisterWrapper = styled.div`
  position: relative;
  z-index: 1;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 15px;

  width: 100%;

  h1 {
    font-size: 24px;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 3.5px;
  }

  animation: logoAnimation 2s ease-in forwards;
`;

export const RepfyLogo = styled.div`
  width: 235px;
  height: 50px;
  transform: translateX(10px);

  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${repfy_logo_white});
`;

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 15px;

  width: 100%;
  max-width: 360px;

  padding: 0 15px;

  color: #fff;

  animation: entering 0.5s ease-in;

  .fields-wrapper__info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    margin: 2em 0 1.5em;
  }

  .fields-wrapper__info__title {
    font-size: 2.4rem;
    text-align: center;
  }

  .fields-wrapper__info__call {
    font-weight: 300;
    font-size: 1.25rem;
    text-align: center;
  }

  .group__wrapper {
    display: flex;
    flex-direction: column;
    gap: 15px;

    width: 100%;
  }

  .fields-wrapper__forgot-password {
    color: var(--blue12);
    font-size: 0.9rem;
    text-decoration: underline;

    margin: 0 15px 0 auto;

    cursor: pointer;
  }

  .checkbox {
    font-weight: 300;
    margin: 0 auto 0 0;
  }

  .button {
    font-size: 1.25rem;
    font-weight: normal;
    text-transform: unset;
    letter-spacing: 1px;

    box-shadow: 0 3px 6px rgb(0 0 0 /23%);
  }

  .fields-wrapper__register {
    margin-top: 20px;
    font-weight: 300;
    b {
      cursor: pointer;
      color: var(--blue12);
      font-weight: bold;
    }
  }
`;

export const ConfirmationModal = styled.div``;
